import { useEffect } from 'react'


const Wait = ({ isActiveWomensMode }) => {

    const LoadPage = async () => {
        try {
            document.getElementById("root").classList.add("BodyComplete")
        } catch (error) {
            
        }
    }

    useEffect(() => {
        LoadPage()
    }, [])

    
    return (
        <>
            {/* Encabezado */}
            {/* <div className='Screen__Wait__Background'>
                {isActiveWomensMode ? (
                    <img src='/img/page/backgrounds/Fondo-SelfieFan-Femenil.jpeg' className='Screen__Wait__Background__Image' />
                ) : isActiveWomensMode === false && (
                    <img src='/img/page/backgrounds/Fondo-SelfieFan-Varonil.jpeg' className='Screen__Wait__Background__Image' />
                )}
            </div> */}

            <div className='Screen__Start__Background'>
                {/* {isActiveWomensMode ? (
                    <img src='/img/page/backgrounds/Fondo-SelfieFan-Femenil.jpeg' className='Screen__Welcome__Background__Image' />
                ) : isActiveWomensMode === false && (
                    <img src='/img/page/backgrounds/Fondo-SelfieFan-Varonil.jpeg' className='Screen__Welcome__Background__Image' />
                )} */}
                {/* <img src='/img/page/backgrounds/background-womens-day-2026.png' className='Screen__Welcome__Background__Image' /> */}

                {/* Atributos vitales para fondos: 
                    autoPlay: inicia solo
                    loop: se repite infinitamente
                    muted: OBLIGATORIO para que los navegadores permitan el autoPlay
                    playsInline: previene que en iOS el video se abra a pantalla completa
                */}
                
                <video 
                    src='/img/page/backgrounds/Fondo-SelfieFan-Varonil-Cadenas-Zoom-Master-2.mp4' 
                    className='SelfieFan__Screen__QR__Background__Video' 
                    autoPlay loop muted playsInline 
                />
            </div>

            {/* Contenido */}
            <section className="Screen__Wait__Container Container-FullHeight">
                <div className="Screen__Wait__Container__Info">
                    <img src="/img/page/xolos-five.png" className="Screen__Wait__Container__Info__Image" alt="Logo" />
                    <p className="Screen__Wait__Container__Title">PREPÁRATE</p>
                    <p className="Screen__Wait__Container__Text">Estamos por comenzar la dinámica</p>
                </div>
            </section>
            
            {/* Pie de página */}
            <footer className='Screen__Wait__Footer'>
                <p className="text-center FooterCredits">Hecho con ♥ por Interaktia | 2026</p>
            </footer>
        </>
    )
}

export { Wait };





{/* <section className="Screen__Wait__Container Container-FullHeight">
    <div className="Screen__Wait__Container__Lines">
        <div className="Screen__Wait__Container__Lines__Line Screen__Wait__Container__Lines__Line--Red"></div>
        <div className="Screen__Wait__Container__Lines__Line Screen__Wait__Container__Lines__Line--White"></div>
        <div className="Screen__Wait__Container__Lines__Line Screen__Wait__Container__Lines__Line--Red"></div>
        <div className="Screen__Wait__Container__Lines__Line Screen__Wait__Container__Lines__Line--White"></div>
    </div>

    <div className="Screen__Wait__Container__Info">
        {/* <img src="/img/brand/logotipo-adsl.png" className="LogoADSL Screen__Wait__Container__Logo" alt="Logo" /> /}
        <img src="/img/page/xolos-five.png" className="Screen__Wait__Container__Info__Image" alt="Logo" />
        <p className="Screen__Wait__Container__Title">PREPÁRATE</p>
        <p className="Screen__Wait__Container__Text">Estamos por comenzar la dinámica</p>
        {/* <p className="text-right w-100 ms-auto">
            <img src="/img/page/xolos-five.png" className="LogoADSL Screen__Wait__Container__Logo d-block text-right" alt="Logo" />
        </p> /}
        {/* <p className="Welcome__Icon"><i className="bi bi-controller"></i></p> /}
        {/* <p className="Welcome__Icon"><i class="bi bi-file-play"></i></p> /}
        {/* <p className="Welcome__Icon"><i class="bi bi-hourglass-split"></i></p> /}
    </div>
</section>

<footer className='Screen__Wait__Footer'>
    <p className="text-center">Hecho con ♥ por Interaktia | 2026</p>
</footer> */}